import { Field as BaseField } from '@base-ui/react/field';
import type * as React from 'react';
import { cn } from '../../lib/cn';

export interface FieldProps extends React.ComponentPropsWithoutRef<typeof BaseField.Root> {
  className?: string;
}

export interface FieldLabelProps extends React.ComponentPropsWithoutRef<typeof BaseField.Label> {
  className?: string;
}

export interface FieldDescriptionProps extends React.ComponentPropsWithoutRef<
  typeof BaseField.Description
> {
  className?: string;
}

export interface FieldErrorProps extends React.ComponentPropsWithoutRef<typeof BaseField.Error> {
  className?: string;
}

export interface FieldControlProps extends Omit<
  React.ComponentPropsWithoutRef<typeof BaseField.Control>,
  'render'
> {
  children: React.ReactElement;
}

export function Field({ className, ...props }: FieldProps) {
  return <BaseField.Root className={cn('flex flex-col items-start gap-1', className)} {...props} />;
}

export function FieldLabel({ className, ...props }: FieldLabelProps) {
  return (
    <BaseField.Label
      className={cn(
        'text-sm font-medium',
        'text-foreground',
        'data-disabled:text-text-disabled data-disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  );
}

export function FieldDescription({ className, ...props }: FieldDescriptionProps) {
  return (
    <BaseField.Description
      className={cn('text-sm', 'text-muted-foreground', className)}
      {...props}
    />
  );
}

export function FieldError({ className, ...props }: FieldErrorProps) {
  return <BaseField.Error className={cn('text-sm', 'text-destructive', className)} {...props} />;
}

export function FieldControl({ children, ...props }: FieldControlProps) {
  return <BaseField.Control render={children} {...props} />;
}
